import { RestorationStatusCodes } from './types';

export const CONSTANTS = {
  DONT_SHOW_RESTORATION_TIME_MODAL: 'dontShowRestorationTime',
  MAP_CONFIG: {
    // [west, south, east, north]
    maxBoundsCoordinates: [
      -124.73192788144308,
      44.5964720761396,
      -120.67058366715625,
      46.136350221553904,
    ] as [number, number, number, number],
    // [west, south, east, north]
    maxBoundsCoordinatesMobile: [
      -123.8382615507315,
      42.982954111841686,
      -121.28042712321886,
      46.60948869130625,
    ] as [number, number, number, number],
    defaultLat: 45.337689123666145,
    defaultLng: -122.67260924395686,
    defaultZoom: 8,
    minZoom: 8,
    minZoomMobile: 6,
    maxZoom: 15,
    maxClusterZoom: 14, //Zoom level after which all the markers are de-clustered. When on max map zoom (15) all the outages will be de-clustered and visible
    maxClusterRadius: 60, //Cluster radius in pixel
    pspsLayerId: 'psps-zone-fill',
  },
  PLAY_STORE_URL:
    'https://play.google.com/store/apps/details?id=com.portlandgeneral.csapp',
  APP_STORE_URL:
    'https://apps.apple.com/us/app/portland-general-electric/id1475828837',
  HELP_MODAL_VIEWED_STORAGE_KEY: 'outagesHelpTipsViewed',
  RESTORATION_STATUSES: {
    [RestorationStatusCodes.POWER_OUT]: [
      'NEW',
      'MNP',
      'RED',
      'RSCH',
      'CRT',
      'ASN',
      'SNT',
      'RCVD',
      'NFY',
      'VFY',
      'C-NEW',
      'F-ASN',
      'F-NEW',
      'S-NEW',
      'S-MNP',
      'S-RED',
      'S-RSCH',
      'S-CRT',
      'S-ASN',
      'S-SNT',
      'S-RCVD',
      'S-NFY',
      'S-VFY',
      'W-ASN',
      'W-RCVD',
      'W-SNT',
    ],
    [RestorationStatusCodes.WERE_ON_IT]: [
      'ENR',
      'ONS',
      'F-ENR',
      'F-ONS',
      'S-ENR',
      'S-ONS',
      'W-ONS',
      'W-ENR',
    ],
    [RestorationStatusCodes.MORE_HELP_NEEDED]: [
      'UAS',
      'SUS',
      'F-UAS',
      'W-UAS',
      'W-SUS',
    ],
    [RestorationStatusCodes.REPAIRS_IN_PROGRESS]: [], //TODO: Add it when crew type is available
    [RestorationStatusCodes.WRAPPING_UP]: [
      'RST',
      'CMP',
      'INC',
      'C-CMP',
      'C-INC',
      'W-CMP',
    ],
    [RestorationStatusCodes.MAINTENANCE_PLANNED]: [
      'P-NEW',
      'P-MNP',
      'P-RED',
      'P-RSCH',
      'P-CRT',
      'P-SUS',
      'P-ASN',
      'P-SNT',
      'P-RCVD',
    ],
    [RestorationStatusCodes.MAINTENANCE_IN_PROGRESS]: ['P-ENR', 'P-ONS'],
    [RestorationStatusCodes.POWER_RESTORED_PLANNED]: [
      'P-RST',
      'P-CMP',
      'P-INC',
      'F-CMP',
    ],
  } as Record<RestorationStatusCodes, string[]>,
  PSPS_ZONES: {
    MT_HOOD_CORRIDOR_FOOTHILLS: 'Mt. Hood Corridor/Foothills',
    COLUMBIA_RIVER_GORGE: 'Columbia River Gorge',
    OREGON_CITY: 'Oregon City',
    ESTACADA: 'Estacada',
    SCOTTS_MILLS: 'Scotts Mills',
    PORTLAND_WEST_HILLS: 'Portland West Hills',
    TUALATIN_MOUNTAINS: 'Tualatin Mountains',
    NORTH_WEST_HILLS: 'North West Hills',
    CENTRAL_WEST_HILLS: 'Central West Hills',
    SOUTHERN_WEST_HILLS: 'Southern West Hills',
    SALEM_HILLS: 'Salem Hills',
    CHEHALEM_MOUNTAINS: 'Chehalem Mountains',
  },
} as const;
